'use strict';

window.$ = jQuery;

require('./polyfills/foreach.js');

//Include theme scripts
require('./ajax.js');
require('./archives.js');
require('./menu.js');
require('./sliders.js');
require('./modals.js');
require('./sticky-header.js');
require('./smooth-scroll.js');
require('./vue.js');

class Theme {
	constructor(msg) {
		//console.log(msg)
	}
}

new Theme('hello');